export default () => ({
    isLoading: true,
    workOrders: [],
    lastEvent: {},
    numErrorsNotified: 0
})